import { createUseStyles } from 'react-jss';

export const useLoginPageStyles = createUseStyles({
  inputStyles: {
    '& input[type="text"], input[type="password"]': {
      backgroundColor: '#0032a0',
      borderBottom: '1px solid #ffffff42',
      color: 'white',
    },
    '& input[placeholder-shown], [placeholder-shown], *[placeholder-shown]': {
      color: 'white',
    },
  },
  heightCalc: {
    height: 'calc(100vh - 80px)',
    '@media (min-width: 768px)': {
      height: 'calc(100vh - 64px)',
    },
  },
});
